module.exports = __webpack_public_path__ + "img/img1logotext.753ce8a3.png";